@if (hasContent) {
  <div [id]="topProductID" class="top-product font-body bg-cover {{ theme?.root }}" [ngClass]="{'border-b border-[#D3DDDF] md:border-b-0': showMobileBorder}" [style]="theme?.bgImage">
    <div class="container mx-auto flex flex-col items-center {{ theme?.container }} {{ showContent ? imgAlign : '' }}">
      <div class="lg:w-1/2 w-full flex-col lg:mr-v-spacing sm:px-v-spacing" [class.lg:!pr-0]="!imgAlign.includes('reverse')"
      [ngClass]="{
                'lg:w-[60%]': topSectionContentSplit === '60-40',
                'lg:w-[70%]': topSectionContentSplit === '70-30',
              }"
        >
        @if (showTitle) {
          <div class="mb-v-spacing top-product__title flex flex-col">
            <div class="flex items-center">
              <span class="inline-block">
                @if (data.productSeal.length > 0 && data.productSeal[0] && data.productSeal[0].url !== null) {
                  <img
                    [src]="data.productSeal[0].url"
                    [alt]="data.productSeal[0].alt"
                    class="mb-3 mr-4 top-product__seal"
                    width="48"
                    height="48"
                    />
                }
              </span>
              @if (data.eyebrow) {
                <div class="wysiwyg inline-block" [innerHTML]="data.eyebrow"></div>
              }
              <!-- REI referral eyebrow: shown only for instituteonline.com-referred sessions with no existing Craft eyebrow -->
              @if (showReiEyebrow) {
                <span class="inline-flex items-center gap-3 mb-4">
                  <img [src]="reiLogoSrc" class="w-auto" style="height: 2em" />
                  <span>{{ reiEyebrowLabel }}</span>
                </span>
              }
            </div>
            @if (data.sectionTitle) {
              <div class="wysiwyg" [innerHTML]="data.sectionTitle"></div>
            }
          </div>
        }
        @if (data.showTrustpilotStars) {
          <div class="my-v-spacing">
            <top-section-trustpilot
              [data]="data"
            ></top-section-trustpilot>
          </div>
        }
        @if (featuredContent) {
          <featured-content [data]="featuredContent" class="pb-4 block"></featured-content>
        }
        @if (showContent) {
          <div
            (click)="activateModalWrapper($event, 'wysiwyg')"
        class="wysiwyg mb-0 top-product__content text-baselg leading-[25px] w-full {{ checkStyle }} {{
          theme?.linkColor === ('text-vis-reverse' || 'text-white')  ? 'darkLink' : ''
        }}"
            [innerHTML]="data.sectionContent"
          ></div>
        }
        <referral-banner></referral-banner>
        <div class="flex flex-col">
          @if (showPricing) {
            <div class="flex flex-col md:flex-row mt-v-spacing">
              <div class="{{ displayOfferTimer ? '' : 'lg:flex-col' }} flex pricing top-product__pricing">
                <div class="flex items-center">
                  <div
                    #prices
                    (click)="activateModalWrapper($event)"
                    class="flex items-center prices"
                    [attr.data-coupon-scroll-target]="pricingText ? couponScrollTarget : null"
                    [innerHtml]="pricingText"
                  ></div>
                  @if (couponApplied) {
                    <span
                      aria-hidden="true"
                      class="coupon-applied text-[13px] font-bold text-ace-pink-700 ml-3 rounded-[30px] py-[7px] px-[15px] bg-[#d9e7f2] whitespace-nowrap"
                      >Coupon Applied!</span
                    >
                  }
                  <!-- Always in the DOM so screen readers announce the text when it is filled in. -->
                  <span class="sr-only" role="status">{{ couponApplied ? 'Coupon applied' : '' }}</span>
                </div>
              </div>
              @if (displayOfferTimer) {
                <div
                  class="timer flex lg:justify-start md:justify-center items-center ml-0 md:ml-2 font-bold"
                  >
                  <div class="mr-1">OFFER ENDS</div>
                  <div class="tracking-wide">
                    @if (daysRemaining) {
                      <span class="day">{{ countdown | async | durationText : 'days' }}:</span>
                    }
                    <span class="hour">{{ countdown | async | durationText : 'hours' }}:</span>
                    <span class="minute">{{ countdown | async | durationText : 'minutes' }}</span>
                    @if (!daysRemaining) {
                      <span>:</span>
                    }
                    @if (!daysRemaining) {
                      <span class="second">{{ countdown | async | durationText : 'seconds' }}</span>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <top-section-button-group
            [secondButtonData]="secondButtonData"
            [wistiaButtonData]="wistiaButtonData"
            [data]="data"
            [product]="product"
            [modalHasContent]="modalHasContent"
            [moneyGuaranteeLabel]="moneyGuaranteeLabel"
            [wistiaCtaData]="wistiaCtaData"
            [ctaButtonData]="ctaButtonData"
            [showScheduleCTA]="showScheduleCTA"
            [hasSecondButtonData]="hasSecondButtonData"
            (ctaVideoPlayEvent)="ctaVideoPlay()"
            (ctaDisplayChange)="handleCtaDisplayChange($event)"
          ></top-section-button-group>
        </div>
      </div>
      @if (data.rightContent || categoryWidgets || showCarousel) {
        <div
          class="lg:w-1/2 w-full flex flex-col mx-auto justify-center py-v-spacing sm:px-v-spacing lg:ml-v-spacing"
          >
          @if (showCarousel) {
            <top-section-carousel
              [carouselData]="data.topSectionCarousel"
              [autoAnimate]="data.slideAutoplay"
            ></top-section-carousel>
          }
          @if (!showCarousel) {
            <top-section-wysiwyg
              [rightContent]="data.rightContent"
              [bottomRightContent]="bottomRightContent"
              [categoryWidgets]="categoryWidgets"
              [data]="data"
            ></top-section-wysiwyg>
          }
        </div>
      }
    </div>
  </div>
}

<top-section-course-popup-banner
  [ctaDisplay]="ctaDisplay"
  [showPriceCta]="showPriceCta"
  [courseOverviewPopup]="courseOverviewPopup"
  [discountPrice]="discountPrice"
  [originalPrice]="originalPrice"
  [percentSavedText]="percentSavedText"
  [data]="data"
  [ctaButtonData]="ctaButtonData"
  [activateModalWrapper]="activateModalWrapper.bind(this)"
  [pricingText]="pricingText"
  [moneyGuaranteeLabel]="moneyGuaranteeLabel"
  [wistiaCtaData]="wistiaCtaData"
></top-section-course-popup-banner>
